import { render } from "./ConferenceApply.vue?vue&type=template&id=23be643d&scoped=true"
import script from "./ConferenceApply.vue?vue&type=script&lang=js"
export * from "./ConferenceApply.vue?vue&type=script&lang=js"

import "./ConferenceApply.vue?vue&type=style&index=0&id=23be643d&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23be643d"]])

export default __exports__